import ReferralSharePage from "./ReferralSharePage";
export default ReferralSharePage;
